<template>
    <div class="widget-table">
        <div class="d-flex flex-wrap justify-content-between align-items-center border-top">
            <div class="col-7 col-sm-8 col-md-3 col-lg-3 col-xl-2 py-3 reviewer__name">
                <span class="text-muted">{{ review.reviewer_name }}</span>
                <div class="mt-1 d-md-none">
                    {{ review.location.name }}
                </div>
            </div>

            <div class="col-md-5 col-lg-4 pl-md-0 col-xl-3 py-3 d-none d-md-block">
                {{ review.location.name }}
            </div>

            <div class="col-xl-3 pl-xl-0 py-3 d-none d-xl-block body-text">
                <text-expand v-if="review.body" :limit="30" :body="review.body">
                    &#8203;<span v-html="review.body"></span>
                </text-expand>
                <em class="no-feedback" v-if="!review.body">(no feedback)</em>
            </div>

            <div class="col-4 col-sm-3 col-md-3 col-lg-2 pl-0 pl-xl-3 py-3 reviewer__rating"
                 v-if="review.rating" :class="{'max-width-for-nps': type === 'nps'}">
                <rating-stars
                        class="mt-1"
                        v-if="type !== 'nps'"
                        style="font-size: 1rem;"
                        :value="review.rating"
                        :disabled="true"
                />
                <nps-rating v-if="type === 'nps'" :rating="review.rating" class="m-auto"></nps-rating>

                <div class="d-md-none mt-1" v-if="!review.rating">
                    <em class="no-feedback">(not rated)</em>
                </div>

                <div class="d-lg-none mt-2" :class="{ 'text-center' : type === 'nps' }">
                    {{ review.review_date | fromNow }}
                </div>
            </div>

            <div class="col-lg-2 py-3 pl-lg-0 pl-xl-3 d-none d-lg-block">
                {{ review.review_date | fromNow }}
            </div>

            <div class="col-1 pl-0 d-xl-none text-center text-primary expanded"
                :class="{ clicked: isExpanded }"
                 @click="isExpanded = !isExpanded">
                <i class="fas fa-angle-double-down expanded__icon"></i>
            </div>

            <div class="col-12 pb-3 body-text body__text__footer d-xl-none" :class="{ expanded__body: isExpanded }">
                <span v-if="review.body" v-html="review.body"></span>
                <em class="no-feedback" v-if="!review.body">(no feedback)</em>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                default: 'public'
            },

            review: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                isExpanded: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .widget-table {
        .no-feedback {
            opacity: 0.5;
        }
    }

    .expanded {
        cursor: pointer;

        &.clicked {

            .expanded__icon {
                transform: rotate(-180deg);
                transition: transform .6s ease-in-out;
            }
        }

        .expanded__icon {
            transition: transform .6s ease-in-out;
        }
    }

    .body__text__footer {
        display: none;

        &.expanded__body {
            display: block;
        }
    }
</style>
